import { type DecimalInput, Decimal, round3 } from './decimal';

/** Converts a quantity in a packaging unit to the product's base unit (quantity × factor). */
export function toBaseQty(quantity: DecimalInput, factor: DecimalInput): Decimal {
  return round3(new Decimal(quantity).times(factor));
}

/** Converts a base-unit quantity back to a packaging unit (baseQuantity / factor). */
export function fromBaseQty(baseQuantity: DecimalInput, factor: DecimalInput): Decimal {
  return round3(new Decimal(baseQuantity).dividedBy(factor));
}
